<!--
  Компактный переключатель кабинета для списка документов ЭДО.
  Показывает название и ИНН кабинета в базовых вкладках.
-->
<template>
  <section class="integration-switcher">
    <BaseTabs
      v-if="integrations.length"
      :model-value="selectedIntegrationKey"
      :tabs="integrationTabs"
      :show-default-context-item="() => false"
      @tab-click="handleTabClick"
    />

    <BaseEmptyState
      v-else
      title="Нет подключённых кабинетов ЭДО"
      description="Подключите интеграцию, чтобы загружать и создавать документы"
      icon="saby"
    >
      <template #actions>
        <base-primary-button @click="$emit('manage')">
          Добавить интеграцию
        </base-primary-button>
      </template>
    </BaseEmptyState>
  </section>
</template>

<script>
export default {
  name: "EdoSabyIntegrationSwitcher",

  props: {
    integrations: {
      type: Array,
      default: () => [],
    },
    selectedIntegrationId: {
      type: [String, Number],
      default: null,
    },
  },

  emits: ["select", "manage"],

  computed: {
    selectedIntegrationKey() {
      return this.selectedIntegrationId
        ? String(this.selectedIntegrationId)
        : "";
    },

    integrationTabs() {
      const tabs = this.integrations.map((integration) => ({
        key: String(integration.id),
        label: this.integrationLabel(integration),
        iconName: "saby",
      }));
      tabs.push({
        key: "settings",
        label: "",
        iconName: "settings",
        iconOnly: true,
        ariaLabel: "Настроить кабинеты ЭДО",
      });
      return tabs;
    },
  },

  methods: {
    integrationLabel(integration) {
      const name = integration.name || integration.org_name || "Кабинет";
      return integration.org_inn
        ? `${name} · ИНН ${integration.org_inn}`
        : name;
    },

    handleTabClick({ key }) {
      if (key === "settings") {
        this.$emit("manage");
        return;
      }

      this.$emit("select", key);
    },
  },
};
</script>

<style scoped>
.integration-switcher {
  margin-bottom: var(--base-out-indent);
}
</style>
